import React from 'react'
import hoistNonReactStatics from 'hoist-non-react-statics'
import { Router as NextRouter, useRouter } from 'next/router'
import { Subtract } from 'utility-types'

// we want our own interface, but today it's identical to
// the next router
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Router extends NextRouter {}

export interface WithRouter {
  router: Router
}

export const withRouter = <P extends WithRouter>(
  Component: React.ComponentType<P>,
) => {
  const RouterComponent = React.forwardRef<any, Subtract<P, WithRouter>>(
    (props, ref) => {
      const router = useRouter()

      return (
        <Component {...(props as unknown as P)} ref={ref} router={router} />
      )
    },
  )

  return hoistNonReactStatics(RouterComponent, Component)
}
